const steps = [
  {
    number: "01",
    icon: "ri-customer-service-2-line",
    title: "Atendimento Inicial",
    description:
      "Realizamos uma consulta completa para ouvir e entender a sua situação, esclarecendo dúvidas e apresentando as possibilidades jurídicas disponíveis para o seu caso.",
  },
  {
    number: "02",
    icon: "ri-file-search-line",
    title: "Análise do Caso",
    description:
      "Analisamos detalhadamente todos os documentos, fatos e evidências, avaliando os riscos, possibilidades e o melhor caminho a ser trilhado para alcançar o resultado desejado.",
  },
  {
    number: "03",
    icon: "ri-task-line",
    title: "Estratégia Jurídica",
    description:
      "Desenvolvemos uma estratégia personalizada, alinhando o plano de ação jurídico às suas necessidades, com clareza sobre cada etapa do processo.",
  },
  {
    number: "04",
    icon: "ri-compass-discover-line",
    title: "Acompanhamento Completo",
    description:
      "Permanecemos ao seu lado em todas as fases do processo, com comunicação transparente e atualizações constantes, garantindo sua tranquilidade durante toda a jornada jurídica.",
  },
];

export default function ComoAtuamos() {
  return (
    <section id="como-atuamos" className="bg-[#550A0D] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="h-px w-12 bg-[#E3B24A]/60" />
            <span className="text-[#E3B24A] font-body text-xs tracking-[0.3em] uppercase font-medium">
              Nosso Processo
            </span>
            <div className="h-px w-12 bg-[#E3B24A]/60" />
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold text-white mb-4">
            Como Atuamos
          </h2>
          <p className="font-body text-[#F2D27A]/70 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Do primeiro contato ao resultado final, acompanhamos cada passo com dedicação, clareza e comprometimento.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={step.number} className="relative group">
              {/* Connector line (desktop) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(50%+2.5rem)] right-0 h-px bg-[#E3B24A]/20 z-0" />
              )}

              <div className="relative z-10 text-center">
                {/* Number + Icon */}
                <div className="relative inline-flex mb-6">
                  <div className="w-20 h-20 flex items-center justify-center rounded-full border-2 border-[#E3B24A]/40 bg-[#E3B24A]/8 group-hover:bg-[#E3B24A]/15 group-hover:border-[#E3B24A]/70 transition-all duration-400">
                    <i className={`${step.icon} text-3xl text-[#E3B24A]`} />
                  </div>
                  {/* Step number badge */}
                  <span className="absolute -top-1 -right-1 w-7 h-7 flex items-center justify-center rounded-full bg-[#E3B24A] text-[#6E0C10] font-body font-bold text-xs">
                    {step.number.replace("0", "")}
                  </span>
                </div>

                {/* Title */}
                <h3 className="font-heading text-xl font-semibold text-white mb-3">
                  {step.title}
                </h3>

                {/* Divider */}
                <div className="w-8 h-0.5 bg-[#E3B24A]/50 mx-auto mb-4" />

                {/* Description */}
                <p className="font-body text-[#F2D27A]/65 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA Banner */}
        <div className="mt-20 relative overflow-hidden rounded-lg border border-[#E3B24A]/20 px-8 py-12">
          <div className="absolute inset-0 bg-[#E3B24A]/5" />
          <div className="relative flex flex-col items-center text-center">
            <h3 className="font-heading text-3xl md:text-4xl font-semibold text-white mb-4">
              Pronto para dar o primeiro passo?
            </h3>
            <p className="font-body text-[#F2D27A]/70 text-base mb-10 max-w-xl">
              Entre em contato agora e receba uma avaliação inicial do seu caso de forma ágil e eficiente.
            </p>
            <a
              href="https://wa.me/5547999300330"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#E3B24A] hover:bg-[#F2D27A] text-[#6E0C10] font-body font-semibold text-base px-10 py-4 rounded-full transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl" />
              <span className="md:hidden">Agendar Consulta</span>
              <span className="hidden md:inline">Agendar Consulta pelo WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
